import { App, Component, createApp, Plugin } from "vue";
import { Router, RouteRecordNormalized, RouteRecordRaw } from "vue-router";
import { createPinia } from "pinia";

import { v2AuthLoader } from "./v2AuthLoader";
import { loadFonts } from "../plugins/webfontloaders";
import { getRum } from "./rum";

import { addRoutes } from "../router";
import { getNavItems } from "./navItems";

import { startDatadog } from "./datadog";
import { useMobileLogin } from "../composables/useMobileLogin";

import i18n from "./i18n";
import { initMobileAuth } from "../composables/mobile_auth";
import { eidLoginHandler } from "./eid_login";

export async function initVueWithAuth(options: {
  app: Component;
  routes?: (RouteRecordRaw | RouteRecordNormalized)[];
  vuetify?: Plugin;
  router?: Router;
}): Promise<App<Element>> {
  // Extracts EID login cookies and sets tokens to local storage
  eidLoginHandler();
  useMobileLogin();

  await initMobileAuth();

  startDatadog();

  const app = createApp(options.app);
  app.use(createPinia());

  await Promise.all([v2AuthLoader(), getNavItems()]);

  await getRum(options.router); // Try to start rum in case we're already logged in
  loadFonts();

  const { routes, vuetify, router } = options;

  if (routes) {
    addRoutes(routes);
  }

  if (vuetify) {
    app.use(vuetify);
  }

  if (router) {
    app.use(router);
  }

  app.use(i18n);

  return app;
}
